import type { ClearQrCodeLinkResponseAction } from './clearQrCodeLink.action';
import type { DuplicateQrCodeLinkResponseAction } from './duplicateQrCodeLink.action';
import type { EditQrCodeLinkResponseAction } from './editQrCodeLink.action';
import type { SetQrCodeLinkDataBasedOnUrlScrapAction } from './setQrCodeLinkDataBasedOnUrlScrap.action';
import type { SubmitQrCodeLinkAction } from './submitQrCodeLink.action';
import type { UpdateHasQrCodeLinkAnalyticTagsStepVisitedResponseAction } from './updateHasQrCodeLinkAnalyticTagsStepVisited.action';
import type { UpdateHasQrCodeLinkCustomLinkDataStepVisitedResponseAction } from './updateHasQrCodeLinkCustomLinkDataStepVisited.action';
import type { UpdateHasQrCodeLinkCustomizeStepVisitedResponseAction } from './updateHasQrCodeLinkCustomizeStepVisited.action';
import type { UpdateHasQrCodeLinkDefineStepVisitedResponseAction } from './updateHasQrCodeLinkDefineStepVisited.action';
import type { UpdateHasQrCodeLinkRedirectsStepVisitedResponseAction } from './updateHasQrCodeLinkRedirectsStepVisited.action';
import type { UpdateQrCodeLinkAndroidResponseAction } from './updateQrCodeLinkAndroid.action';
import type { UpdateQrCodeLinkAndroidRedirectResponseAction } from './updateQrCodeLinkAndroidRedirect.action';
import type { UpdateQrCodeLinkCampaignResponseAction } from './updateQrCodeLinkCampaign.action';
import type { UpdateQrCodeLinkChannelResponseAction } from './updateQrCodeLinkChannel.action';
import type { UpdateQrCodeLinkCustomLinkDataResponseAction } from './updateQrCodeLinkCustomLinkData.action';
import type { UpdateQrCodeLinkFeatureResponseAction } from './updateQrCodeLinkFeature.action';
import type { UpdateQrCodeLinkHasBlacklistErrorResponseAction } from './updateQrCodeLinkHasBlacklistError.action';
import type { UpdateQrCodeLinkIosResponseAction } from './updateQrCodeLinkIos.action';
import type { UpdateQrCodeLinkIosRedirectResponseAction } from './updateQrCodeLinkIosRedirect.action';
import type { UpdateQrCodeLinkIsWebOnlyResponseAction } from './updateQrCodeLinkIsWebOnly.action';
import type { UpdateQrCodeLinkQrCodeCustomizationResponseAction } from './updateQrCodeLinkQrCodeCustomization.action';
import type { UpdateQrCodeLinkStepResponseAction } from './updateQrCodeLinkStep.action';
import type { UpdateQrCodeLinkTagsResponseAction } from './updateQrCodeLinkTags.action';
import type { UpdateQrCodeLinkTitleResponseAction } from './updateQrCodeLinkTitle.action';

export type QrCodeLinkCreatorAction =
  | ClearQrCodeLinkResponseAction
  | UpdateQrCodeLinkStepResponseAction
  | UpdateHasQrCodeLinkDefineStepVisitedResponseAction
  | UpdateHasQrCodeLinkAnalyticTagsStepVisitedResponseAction
  | UpdateHasQrCodeLinkRedirectsStepVisitedResponseAction
  | UpdateHasQrCodeLinkCustomLinkDataStepVisitedResponseAction
  | UpdateHasQrCodeLinkCustomizeStepVisitedResponseAction
  | UpdateQrCodeLinkHasBlacklistErrorResponseAction
  | UpdateQrCodeLinkTitleResponseAction
  | UpdateQrCodeLinkFeatureResponseAction
  | UpdateQrCodeLinkChannelResponseAction
  | UpdateQrCodeLinkCampaignResponseAction
  | UpdateQrCodeLinkTagsResponseAction
  | UpdateQrCodeLinkIosResponseAction
  | UpdateQrCodeLinkIosRedirectResponseAction
  | UpdateQrCodeLinkAndroidResponseAction
  | UpdateQrCodeLinkAndroidRedirectResponseAction
  | UpdateQrCodeLinkIsWebOnlyResponseAction
  | UpdateQrCodeLinkCustomLinkDataResponseAction
  | UpdateQrCodeLinkQrCodeCustomizationResponseAction
  | EditQrCodeLinkResponseAction
  | DuplicateQrCodeLinkResponseAction
  | SetQrCodeLinkDataBasedOnUrlScrapAction
  | SubmitQrCodeLinkAction;

export * from './clearQrCodeLink.action';
export * from './updateQrCodeLinkStep.action';
export * from './updateHasQrCodeLinkDefineStepVisited.action';
export * from './updateHasQrCodeLinkAnalyticTagsStepVisited.action';
export * from './updateHasQrCodeLinkRedirectsStepVisited.action';
export * from './updateHasQrCodeLinkCustomLinkDataStepVisited.action';
export * from './updateHasQrCodeLinkCustomizeStepVisited.action';
export * from './updateQrCodeLinkHasBlacklistError.action';
export * from './updateQrCodeLinkTitle.action';
export * from './updateQrCodeLinkFeature.action';
export * from './updateQrCodeLinkChannel.action';
export * from './updateQrCodeLinkCampaign.action';
export * from './updateQrCodeLinkTags.action';
export * from './updateQrCodeLinkIos.action';
export * from './updateQrCodeLinkIosRedirect.action';
export * from './updateQrCodeLinkAndroid.action';
export * from './updateQrCodeLinkAndroidRedirect.action';
export * from './updateQrCodeLinkIsWebOnly.action';
export * from './updateQrCodeLinkCustomLinkData.action';
export * from './updateQrCodeLinkQrCodeCustomization.action';
export * from './editQrCodeLink.action';
export * from './duplicateQrCodeLink.action';
export * from './setQrCodeLinkDataBasedOnUrlScrap.action';
export * from './submitQrCodeLink.action';
